export enum ExternalDriverAllowedActions {
    VIEW_24_7 = 'view_24_7',
    INVITE_TO_APP = 'invite_to_app',
    CHAT = 'chat',
}

export enum ExternalVehicleAllowedActions {
    VIEW_24_7 = 'view_24_7',
}
